<template>
  <v-card width="90%" style="margin: 15px auto;">
    <ViewTmpl v-if="process" :process="process"/>
    <v-card-actions>
      <v-btn color="default" @click="$router.go(-1)">назад</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="print(card)">Печать</v-btn>
      <v-btn color="primary" @click="exportDocx(card)">Экспорт .docx</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ViewTmpl from './components/ViewTmpl.vue'

export default {
  components: { ViewTmpl },
  data: () => ({ process: null }),
  methods: {
    print() {
      this.$axios.get('/manufacture/process-template/print', {
        params: { id: this.$route.query.id },
        responseType: 'blob'
      }).then(r => {
        const file = new Blob([r.data],  { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL, '_blank');
      })
    },
    exportDocx() {
      this.$axios.get('/manufacture/process-template/export-docx', {
        params: { id: this.$route.query.id },
        responseType: 'blob'
      }).then(response => {
        let fileName = response.headers["content-disposition"].split("filename=")[1];
        fileName = fileName.substring(1, fileName.length - 1)
        if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
          window.navigator.msSaveOrOpenBlob(
            new Blob([response.data],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
          ), fileName);
        } else {
          const url = window.URL.createObjectURL(new Blob(
            [response.data],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
          ));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove()
        }
      }).catch(() => {})
    },
    getProcess() {
      this.$axios.get('/manufacture/process-template/view', {
        params: { id: this.$route.query.id }
      }).then(r => {
        this.process = r.data
      })
    }
  },
  mounted() {
    this.getProcess()
  }
}
</script>
